import { cipo } from "cipo";
import { DialogClosed } from "../../src/app/signal-store";

const MODULE_SOVI = -5;
const MODULE_TYPE_URL = 2;
const MODULE_TYPE_REPORTING = 6;

cipo.factory(
  "angularJsService",
  function (
    userService,
    $mdDialog,
    $document,
    $state,
    Dictionaries,
    jsToNg,
    PdfHandler,
    WorkflowEntityInstance,
    fileService,
    Message,
    URI,
    AttachmentHandler,
    PSPDFKIT_CONFIG,
    OFFICE_MIME_TYPES,
    AUDIO_MIME_TYPES,
    VIDEO_MIME_TYPES,
  ) {
    var service = {};

    service.goToVoid = function () {
      $state.transitionTo(
        "void",
        {},
        {
          notify: false, // No state change events
          location: false, // Do not change URL
        },
      );
    };

    service.setContextTree = function (contextTree) {
      userService.setContextTree(contextTree);
    };

    service.setUser = function (user) {
      userService.setUser(user);
    };

    service.setTenants = function (tenants) {
      userService.setTenants(tenants);
    };

    service.setModules = function (modules) {
      userService.setModules(modules);
    };

    service.setActiveTenant = function (tenant) {
      userService.setActiveTenant(tenant);
    };

    service.closeAllDialogs = function () {
      $mdDialog.cancel();
    };

    service.resetLoadingMenuFlags = function () {
      userService.resetLoadingMenuFlags();
    };

    service.openAttachment = function (attachments, id) {
      // set mime types, file and css class based on mime type, if missing
      attachments = (attachments || []).map((att) => {
        return fileService.setMimeTypeFromExt(att);
      });
      var attachmentHandler = new AttachmentHandler();
      var x = attachments.find((att) => att.id === id);
      if (PSPDFKIT_CONFIG.MIME_TYPES.includes(x.mimeType)) {
        var viewableAttachments = attachments.filter((att) =>
          PSPDFKIT_CONFIG.MIME_TYPES.includes(att.mimeType),
        );
        attachmentHandler.openAttachment(x.id, viewableAttachments);
      } else if (OFFICE_MIME_TYPES.includes(x.mimeType)) {
        attachmentHandler.open(x);
      } else if (
        AUDIO_MIME_TYPES.includes(x.mimeType) ||
        VIDEO_MIME_TYPES.includes(x.mimeType)
      ) {
        attachmentHandler.open(x);
      }
    };

    service.editContract = function (item, ev) {
      if (!item || !item.isInitiator) {
        item = { ...item, isInitiator: false };
        if (!item.entityInstanceId) {
          item = { ...item, ...userService.system.context.contract };
        }
      }
      $mdDialog
        .show({
          locals: {
            item: item,
            module: userService.system.modules["CT"],
            screenId: item?.screenId || null,
          },
          controller: "editHContractController",
          templateUrl: "/ng/views/admin/modals/editHContract.html",
          parent: angular.element(document.body),
          targetEvent: ev,
          fullscreen: true,
          escapeToClose: false,
          clickOutsideToClose: false,
          disableParentScroll: true,
          multiple: true,
        })
        .then(
          function () {
            userService.isCurrentContractPeriodsChanged = true;
            userService.isReloadGrid = true;
            userService.triggerMenuRefresh();
            userService.triggerRefreshInAngular({ context: true });
            jsToNg.dialogClosed(DialogClosed.Contract);
          },
          function () {
            // Unchanged close ($mdDialog.cancel) — no menu/context refresh needed.
          },
        );
    };

    service.changeContext = function (context, addLastUsedContract) {
      userService.setContext(context, addLastUsedContract).then(function () {
        if ($state.current.code == "DYN-MREP") {
          var params = angular.copy($state.params);
          var module = userService.getModuleObjectById($state.params.id) || {};

          params.contractId = module.perContract ? context.contract.id : 0;
          $state.transitionTo($state.current.name, params, {
            reload: true,
            inherit: true,
            notify: true,
          });
        }
      });
    };

    service.openDocument = function (item, smallerFullscreen) {
      if (item?.moduleId === MODULE_SOVI) {
        // this document canot be open
        jsToNg.dialogClosed(item.entityInstanceId);
        return;
      }
      $mdDialog
        .show({
          locals: {
            item: {
              ...item,
              itemId: item.entityInstanceId,
              returnEntityInstanceOnClose: true,
            },
            module: {
              moduleId: item.moduleId,
              code: item.moduleCode,
              name: item.moduleName,
              perContract: !!item.contractId,
            },
            contractId: item.contractId,
            smallerFullscreen: !!smallerFullscreen,
            screenId: item.screenId,
          },
          controller: "SaveWorkflowEntityInstanceController",
          templateUrl:
            "/ng/views/dynamics/modals/saveWorkflowEntityInstance.html",
          parent: angular.element(document.body),
          fullscreen: true,
          multiple: true,
          escapeToClose: false,
          clickOutsideToClose: false,
        })
        .then(
          function (result) {
            jsToNg.dialogClosed(result?.entityInstanceId);
          },
          function (result) {
            jsToNg.dialogClosed(result?.entityInstanceId);
          },
        );
    };

    service.closeDialog = function () {
      $mdDialog.hide();
    };

    service.openModuleSettings = function (module) {
      var obj = module;
      var moduleOperations = userService.getOperationsFor("M");
      obj.isConfig = true;
      var moduleObj = {
        abbreviation: obj.code,
        disabled: false,
        iconId: obj.iconId,
        id: obj.moduleId,
        isSystem: obj.typeId == 3 ? true : false,
        name: obj.name,
        perContract: obj.perContract,
        color: obj.color,
      };
      $mdDialog
        .show({
          locals: {
            obj: moduleObj,
            simplifiedVersion: false,
            operations: moduleOperations,
            module: obj,
          },
          controller: "editNModuleController",
          templateUrl: "/ng/views/admin/modals/editNModule.html",
          parent: angular.element(document.body),
          targetEvent: null,
          fullscreen: true,
          focusOnOpen: false,
          escapeToClose: false,
          multiple: true,
          clickOutsideToClose: false,
          hasBackdrop: false,
        })
        .then(
          function (result) {
            obj.code = result.abbr;
            $document[0].title = "CIPO® Software - " + module.name;
            userService.isReloadGrid = result.isReloadGrid;
            userService.triggerMenuRefresh();
            userService.isReloadModuleInformation =
              result.isReloadModuleInformation || false;
            Dictionaries.RoleUsers({
              id: obj.moduleId,
              permissionId: 1,
              contractId: userService.system.userdata.contractId,
            }).then(function (r) {
              obj.roles = r;
            });
            jsToNg.dialogClosed(DialogClosed.ModuleSettings);
          },
          function (isReloadGrid) {
            userService.isReloadGrid = isReloadGrid;
            userService.triggerMenuRefresh();
            Dictionaries.RoleUsers({
              id: obj.moduleId,
              permissionId: 1,
              contractId: userService.system.userdata.contractId,
            }).then(function (r) {
              obj.roles = r;
            });
          },
        )
        .finally(function () {
          jsToNg.dialogClosed(DialogClosed.ModuleSettings);
        });
    };

    service.openModuleDefinitionEditor = function (module, typeId, ev) {
      var modulesModule = userService.system.modules["M"];
      var moduleOperations = userService.getOperationsFor("M");
      var targetTypeId = module ? module.typeId : typeId;

      if (
        targetTypeId == MODULE_TYPE_URL ||
        targetTypeId == MODULE_TYPE_REPORTING
      ) {
        return $mdDialog
          .show({
            locals: {
              obj: module || null,
              simplifiedVersion: false,
              operations: moduleOperations,
              module: modulesModule,
              typeId: targetTypeId,
            },
            controller: "editUrlController",
            templateUrl: "/ng/views/admin/modals/editUrl.html",
            parent: angular.element(document.body),
            targetEvent: ev,
            fullscreen: true,
            escapeToClose: false,
            clickOutsideToClose: false,
            multiple: true,
          })
          .then(
            function () {
              userService.triggerMenuRefresh();
              jsToNg.dialogClosed(DialogClosed.ModuleSettings);
            },
            function () {
              // Plain close/cancel: no changes were persisted.
            },
          );
      }

      return $mdDialog
        .show({
          locals: {
            obj: module || null,
            simplifiedVersion: false,
            operations: moduleOperations,
            module: modulesModule,
          },
          controller: "editNModuleController",
          templateUrl: "/ng/views/admin/modals/editNModule.html",
          parent: angular.element(document.body),
          targetEvent: ev,
          fullscreen: true,
          focusOnOpen: false,
          escapeToClose: false,
          multiple: true,
          clickOutsideToClose: false,
        })
        .then(
          function (result) {
            if (result && result.properties) {
              service.openDuplicateModule(result.properties);
              return;
            }
            userService.triggerMenuRefresh();
            jsToNg.dialogClosed(DialogClosed.ModuleSettings);
          },
          function (isReloadGrid) {
            if (isReloadGrid) {
              userService.triggerMenuRefresh();
              jsToNg.dialogClosed(DialogClosed.ModuleSettings);
            }
          },
        );
    };

    service.openDuplicateModule = function (moduleToDuplicate, exportList) {
      return $mdDialog
        .show({
          locals: {
            module: userService.system.modules["M"],
            moduleToDuplicate: moduleToDuplicate || null,
            exportList: exportList || null,
          },
          controller: "duplicateModuleController",
          templateUrl: "/ng/views/admin/modals/duplicateModule.html",
          parent: angular.element(document.body),
          fullscreen: true,
          focusOnOpen: false,
          escapeToClose: false,
          multiple: true,
          clickOutsideToClose: false,
          disableParentScroll: true,
        })
        .then(
          function () {
            if (!exportList) {
              userService.triggerMenuRefresh();
              jsToNg.dialogClosed(DialogClosed.ModuleSettings);
            }
          },
          function () {
            // Plain close/cancel: no changes were persisted.
          },
        );
    };

    service.openImportModuleDefinition = function () {
      return $mdDialog
        .show({
          locals: {
            action: {
              uploadUrl: URI.MODULES.IMPORT,
              accept: "application/json",
              multiple: false,
              closesOnFinish: true,
            },
            acceptedMimeTypes: "application/json",
          },
          controller: "importUploadController",
          templateUrl: "/ng/views/admin/modals/fmUpload.html",
          parent: angular.element(document.body),
          fullscreen: true,
          focusOnOpen: false,
          escapeToClose: false,
          multiple: true,
          clickOutsideToClose: false,
          disableParentScroll: true,
        })
        .then(
          function () {
            userService.triggerMenuRefresh();
            jsToNg.dialogClosed(DialogClosed.ModuleSettings);
          },
          function () {
            // Plain close/cancel: no changes were persisted.
          },
        );
    };

    service.autoTriggerBulkTransition = function (
      entityInstance,
      transition,
      role,
    ) {
      try {
        entityInstance
          .init(false, false)
          .then(() => entityInstance.startTransition(transition, role))
          .then(() => entityInstance.triggerMultiTransition())
          .then(() => jsToNg.dialogClosed(DialogClosed.DmTransitionEnd));
      } catch (error) {
        console.error(error);
      }
    };

    service.executeTransition = function (props) {
      const { rows, transition, role, moduleId, contractId } = props;
      const module = userService.getModuleObjectById(moduleId);
      var entityInstanceIdList = (rows || [])
        .map((r) => r.entity_instance_id)
        .filter((r) => r);
      var progressPaymentInfo = (rows || []).map((r) => ({
        entityInstanceId: r.entity_instance_id,
        paymentPeriodId: r.payment_period_id,
      }));
      var presetsIdList = (rows || [])
        .map((r) => r.entity_template_id)
        .filter((r) => r);
      if (rows && rows.length) {
        // creates a workflow instance from given data
        var entityInstance = new WorkflowEntityInstance({
          moduleId,
          moduleCode: module.code,
          moduleName: module.name,
          entityInstanceId: entityInstanceIdList[0],
          perContract: module.perContract,
          contractId,
          entityInstanceIdList,
          presetsIdList,
          progressPaymentInfo,
        });

        // Check if we have required field not set
        entityInstance
          .checkRequiredFields(entityInstanceIdList, transition.id)
          .then(function (result) {
            if (result && result.length) {
              Message.warning(
                "Please fill in required fields on documents " +
                  result.join(", ") +
                  " and try again",
              );
            } else {
              entityInstance
                .checkSignTransition(transition.id)
                .then(function (result) {
                  // if transition is autotrigger, then we don't need to show the popup- only start the transition
                  if (transition.isAutoTrigger && !result) {
                    service.autoTriggerBulkTransition(
                      entityInstance,
                      transition,
                      role,
                    );
                  } else {
                    $mdDialog
                      .show({
                        locals: {
                          module,
                          contractId,
                          entityInstanceIdList,
                          presetsIdList,
                          progressPaymentInfo,
                          transition,
                          role,
                        },
                        controller:
                          "SaveMultipleWorkflowEntityInstanceController",
                        templateUrl:
                          "/ng/views/dynamics/modals/saveMultipleWorkflowEntityInstance.html",
                        parent: angular.element(document.body),
                        fullscreen: true,
                        escapeToClose: false,
                        multiple: true,
                        clickOutsideToClose: false,
                      })
                      .then(() =>
                        jsToNg.dialogClosed(DialogClosed.DmTransitionEnd),
                      );
                  }
                });
            }
          });
      }
    };

    // Pdf handler
    service.pdfHandler = {};

    service.initPdfHandler = function (props) {
      service.pdfHandler = new PdfHandler({
        isLoading: function (isLoading) {
          self.loading = isLoading;
        },
        moduleId: props.moduleId,
        moduleName: props.moduleName,
        moduleCode: props.moduleCode,
        contractId: props.contractId,
        entityInstanceId: props.entityInstanceId,
        contractNo: props.contractNo,
        clearSelectedRows: function () {
          jsToNg.dialogClosed({ clearSelectedRows: true });
        },
        correspondenceOperations: props.correspondenceOperations,
      });
    };

    service.downloadRows = function (rows) {
      service.pdfHandler.download(rows);
    };

    service.printDocuments = function (rows) {
      service.pdfHandler.printDocuments(rows);
    };

    service.emailDocuments = function (rows) {
      service.pdfHandler.email(rows);
    };

    service.openImportEntitiesDialog = function (props) {
      $mdDialog
        .show({
          locals: {
            moduleId: props.moduleId,
            moduleCode: props.moduleCode,
            importOptions: { closeOnSuccess: true },
          },
          controller: "importEntitiesController",
          templateUrl: "/ng/controllers/files/importEntities.html",
          parent: angular.element(document.body),
          fullscreen: true,
          focusOnOpen: false,
          multiple: false,
          escapeToClose: false,
          clickOutsideToClose: false,
        })
        .finally(function () {
          jsToNg.dialogClosed(DialogClosed.DmImport);
        });
    };

    service.openReportsDialog = function (props) {
      $mdDialog.show({
        locals: { module: userService.system.modules[props.moduleCode] },
        controller: "manageReportsController",
        templateUrl: "/ng/views/admin/modals/manageReports.html",
        parent: angular.element(document.body),
        // targetEvent: ev,
        fullscreen: true,
        focusOnOpen: false,
        multiple: false,
        escapeToClose: false,
        clickOutsideToClose: false,
      });
    };

    service.openTransitionForm = function (params) {
      const dataURL = params.isComment
        ? URI.MODULE.ADD_COMMENT
        : URI.SOV.SOV_SAVE;

      $mdDialog
        .show({
          locals: {
            info: params.fields,
            transition: params.transition,
            entityInstanceId: params.entityInstanceId,
            dataURL: dataURL,
            contractId: params.contractId,
            isPayment: params.isPayment,
            selectedRoleId: params.roleId,
            startScreenValues: [],
          },
          controller: "editTransitionScreenController",
          templateUrl: "/ng/views/admin/modals/editTransitionScreen.html",
          parent: angular.element(document.body),
          fullscreen: true,
          escapeToClose: false,
          clickOutsideToClose: false,
        })
        .then(
          function () {
            jsToNg.dialogClosed(DialogClosed.SovTransitionForm);
          },
          function () {
            jsToNg.dialogClosed(DialogClosed.SovCancel);
          },
        );
    };

    service.importSOVWithCategories = function (params) {
      $mdDialog
        .show({
          locals: {
            moduleId: params.moduleId,
            moduleCode: params.moduleCode,
            importOptions: {
              fieldsForImportDatasource: "fieldsForImportSOV",
              moduleIdForStates: params.moduleIdForStates,
              importUrlData: URI.SOV.IMPORT_DOCS,
              entityInstanceId: params.entityInstanceId,
              closeOnSuccess: true,
              closeOnError: true,
            },
          },
          controller: "importEntitiesController",
          templateUrl: "/ng/controllers/files/importEntities.html",
          parent: angular.element(document.body),
          fullscreen: true,
          focusOnOpen: false,
          multiple: false,
          escapeToClose: false,
          clickOutsideToClose: false,
        })
        .then(
          function (output) {
            service.handleOutputFromImportSOVWithCategories(
              output,
              params.entityInstanceId,
            );
          },
          function (output) {
            service.handleOutputFromImportSOVWithCategories(
              output,
              params.entityInstanceId,
            );
          },
        );
    };

    service.handleOutputFromImportSOVWithCategories = function (
      output,
      entityInstanceId,
    ) {
      if (output && (output.importError || output.success)) {
        jsToNg.dialogClosed({
          entityInstanceId: entityInstanceId,
          type: DialogClosed.SovImport,
        });
      } else {
        jsToNg.dialogClosed(DialogClosed.SovCancel);
      }
    };

    service.openSOVI = function (params, editable) {
      var item = params.row || {};
      item.entityInstanceId = params.entityInstanceId;
      item.editable = editable ?? false;

      $mdDialog
        .show({
          locals: {
            item: item,
            contractId: params.contractId,
            operations: params.sovOperations,
            sovEntityInstanceId: params.sovEntityInstanceId,
          },
          controller: "editSovItemController",
          templateUrl: "/ng/views/admin/modals/editSovItem.html",
          parent: angular.element(document.body),
          fullscreen: true,
          escapeToClose: false,
          clickOutsideToClose: false,
        })
        .then(
          function (r) {
            // Add categories if existing
            const categoryIds = [];
            if (r.end) {
              categoryIds.push(Number(r.end));
            }
            if (r.start) {
              categoryIds.push(Number(r.start));
            }

            // Add wbs nodes if existing
            const wbsNodeIds = [];
            if (r.endWBS) {
              wbsNodeIds.push(Number(r.endWBS));
            }
            if (r.startWBS) {
              wbsNodeIds.push(Number(r.startWBS));
            }

            jsToNg.dialogClosed({
              categoryIds,
              wbsNodeIds,
              type: DialogClosed.SovItem,
            });
          },
          function () {
            jsToNg.dialogClosed(DialogClosed.SovCancel);
          },
        );
    };

    service.openSOVForm = function (params) {
      $mdDialog
        .show({
          locals: {
            info: params.fields,
            contractId: params.contractId,
            entityInstanceId: params.entityInstanceId,
            screenId: params.screenId,
            isDraftState: params.isDraftState,
            documentNumber: params.documentNumber,
            saveDocument: true,
            createURI: URI.SOV.SOV_CREATE,
            saveURI: URI.SOV.SOV_SAVE,
            moduleName: params.moduleName,
            showSuccessMessage: params.showSuccessMessage,
            uriParams: {
              contractId: params.contractId,
              workflowId: params.workflowId,
              entityInstanceId: params.entityInstanceId,
              categoryGroupId: params.categoryGroupId,
              soviScreenId: params.soviScreenId,
            },
          },
          controller: "editScreenController",
          templateUrl: "/ng/views/admin/modals/editScreen.html",
          parent: angular.element(document.body),
          fullscreen: true,
          escapeToClose: false,
          clickOutsideToClose: false,
        })
        .then(
          function (entityInstanceId) {
            jsToNg.dialogClosed({
              entityInstanceId,
              type: DialogClosed.SovAdd,
            });
          },
          function () {
            jsToNg.dialogClosed(DialogClosed.SovCancel);
          },
        );
    };

    service.openPPForm = function (params) {
      $mdDialog
        .show({
          locals: {
            info: params.fields,
            workflowId: params.workflowId,
            contractId: params.contractId,
            entityInstanceId: params.entityInstanceId,
            screenId: params.screenId,
            isDraftState: params.isDraftState,
            documentNumber: params.documentNumber,
            saveDocument: true,
            createURI: URI.PROGRESS_PAYMENT.PP_CREATE,
            saveURI: URI.PROGRESS_PAYMENT.PP_SAVE,
            moduleName: params.moduleName,
            showSuccessMessage: true,
            uriParams: {
              contractId: params.contractId,
              workflowId: params.workflowId,
              screenId: params.screenId,
              entityInstanceId: params.entityInstanceId,
              paymentPeriodId: params.paymentPeriodId,
              moduleTypeId: params.moduleTypeId,
              sovEntityInstanceId: params.sovEntityInstanceId,
            },
          },
          controller: "editScreenController",
          templateUrl: "/ng/views/admin/modals/editScreen.html",
          parent: angular.element(document.body),
          fullscreen: true,
          escapeToClose: false,
          clickOutsideToClose: false,
        })
        .then(
          function (entityInstanceId) {
            jsToNg.dialogClosed({
              entityInstanceId,
              paymentPeriodId: params.paymentPeriodId,
              type: DialogClosed.PPAdd,
            });
          },
          function () {
            jsToNg.dialogClosed(DialogClosed.PPCancel);
          },
        );
    };

    service.openPdfMarkup = function (props) {
      const { documentId, fileId, title, entityInstanceId } = props;
      $mdDialog.show({
        locals: {
          module: userService.system.modules["FCM"],
          documentId,
          fileUrl: null,
          fileId,
          title,
          mimeType: "application/pdf",
          entityInstanceId,
        },
        controller: "pspdfkitViewerController",
        templateUrl: "/ng/views/admin/modals/pspdfkitViewer.html",
        parent: angular.element(document.body),
        fullscreen: true,
        escapeToClose: false,
        clickOutsideToClose: false,
        disableParentScroll: true,
        multiple: true,
      });
    };

    service.addNewPdfMarkup = function () {
      $mdDialog
        .show({
          locals: {},
          controller: "pdfMarkupAddController",
          templateUrl: "/ng/views/admin/modals/pdfMarkupAdd.html",
          parent: angular.element(document.body),
          fullscreen: true,
          multiple: true,
        })
        .then(function (result) {
          if (result && result.documentId) {
            jsToNg.dialogClosed({
              type: DialogClosed.PdfMarkupAdd,
              documentId: result.documentId,
              fileId: result.fileId,
              fileName: result.fileName,
            });
          } else if (result && result.filesUploaded) {
            jsToNg.dialogClosed({ type: DialogClosed.PdfMarkupAdd });
          }
        });
    };

    service.showDialogToSaveAttachments = function (
      isProjectFile,
      attachmentIds,
      attachments,
    ) {
      fileService.selectFolder(isProjectFile, attachmentIds, attachments);
    };

    return service;
  },
);
